/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Glad_Weak_Fish_DineInputs */

const en_glad_weak_fish_dine = /** @type {(inputs: Glad_Weak_Fish_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set access context`)
};

const de_glad_weak_fish_dine = /** @type {(inputs: Glad_Weak_Fish_DineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontext auswählen`)
};

/**
* | output |
* | --- |
* | "Set access context" |
*
* @param {Glad_Weak_Fish_DineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const glad_weak_fish_dine = /** @type {((inputs?: Glad_Weak_Fish_DineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Glad_Weak_Fish_DineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_glad_weak_fish_dine(inputs)
	return de_glad_weak_fish_dine(inputs)
});